/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

import HeaderOne from "../../../common/header/HeaderOne";
import FooterOne from "../../../common/footer/FooterOne";

import cutout1 from "../../../../src/app/assets/images/ncco-media/cutout1.jpg";
import banner from "../../../../src/app/assets/images/ncco-media/banner.jpg";
import cutout2 from "../../../../src/app/assets/images/kpo-media/cutout2.jpg";

// brand logo imports

import c1 from "../../../app/assets/images/banner/c1.jpg";
import c2 from "../../../app/assets/images/banner/c2.jpg";
import c3 from "../../../app/assets/images/banner/c3.jpg";
import c4 from "../../../app/assets/images/banner/c4.jpg";
import c5 from "../../../app/assets/images/banner/c5.jpg";
import c6 from "../../../app/assets/images/banner/c6.jpg";
import c7 from "../../../app/assets/images/banner/c7.jpg";
import c8 from "../../../app/assets/images/banner/c8.jpg";
import c9 from "../../../app/assets/images/banner/c9.jpg";
import c10 from "../../../app/assets/images/banner/c10.jpg";
import c11 from "../../../app/assets/images/banner/c11.jpg";
import c12 from "../../../app/assets/images/banner/c12.jpg";
import c13 from "../../../app/assets/images/banner/c13.jpg";
import c14 from "../../../app/assets/images/banner/c14.jpg";
import c15 from "../../../app/assets/images/banner/c15.jpg";
import c16 from "../../../app/assets/images/banner/c16.jpg";
import c17 from "../../../app/assets/images/banner/c17.jpg";
import c19 from "../../../app/assets/images/banner/c19.jpg";
import c20 from "../../../app/assets/images/banner/c20.jpg";
import c21 from "../../../app/assets/images/banner/c21.png";
import c22 from "../../../app/assets/images/banner/c22.png";
import c23 from "../../../app/assets/images/banner/c23.png";
import c24 from "../../../app/assets/images/banner/c24.png";
import c25 from "../../../app/assets/images/banner/c25.png";
import c26 from "../../../app/assets/images/banner/c26.png";
import c27 from "../../../app/assets/images/banner/c27.png";
import c28 from "../../../app/assets/images/banner/c28.png";
import c29 from "../../../app/assets/images/banner/c29.png";
import c30 from "../../../app/assets/images/banner/c30.png";
import c31 from "../../../app/assets/images/banner/c31.png";

// icons import

import icon1 from "../../../app/assets/images/ncco-media/icon1.png";
import icon2 from "../../../app/assets/images/ncco-media/icon2.png";
import icon3 from "../../../app/assets/images/ncco-media/icon3.png";
import icon4 from "../../../app/assets/images/ncco-media/icon4.png";
import icon5 from "../../../app/assets/images/ncco-media/icon5.png";
import icon6 from "../../../app/assets/images/ncco-media/icon6.png";
import icon7 from "../../../app/assets/images/ncco-media/icon7.png";

const Products = () => {
const properties = {
prevArrow: (
<button className="cs-btn btn-left">
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left"
		viewBox="0 0 16 16">
		<path fill-rule="evenodd"
			d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
	</svg>
</button>
),
nextArrow: (
<button className="cs-btn btn-right">
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
		viewBox="0 0 16 16">
		<path fill-rule="evenodd"
			d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
	</svg>
</button>
),
};

return (
<div className="ncco-page">
	<HeaderOne />
	<section
		class="d-flex align-items-center justify-content-center banner-sec callcenter-sec text-center text-lg-start position-relative section-padding">
		<div class="container custom-cn-width position-relative z-index-1">
			<div class="row align-items-center justify-content-center justify-content-lg-between g-xl-5 g-4">
				<div class="col-xl-5 col-lg-6 col-md-9">
					<h2 class="pb-3 text-white">Nearshore Call Center Outsourcing with all the benefits and none of the
						hassles.</h2>
					<p class="text-white">CAP Digisoft’s Nearshore Call Center outsourcing is an increasingly popular
						alternative for businesses looking to benefit from the advantages of contracting outsourced call
						center services without the potential pitfalls that are associated with offshore and farshore
						teams. We can increase your conversion results and your ROI with all the benefits of working
						with a US-based partner </p>
				</div>
				<div class="col-xl-6 col-lg-6 col-md-9">
					<img src={banner} class="img-fluid" alt="" />
				</div>
			</div>
		</div>
	</section>
	<section className="section-padding">
		<div class="container custom-cn-width text-center">
			<div class="row g-5 justify-content-center text-center">
				<div class="col-lg-12 mb-4 mb-lg-5">
					<h1 class="fw-light">We’re a full-service partner to your success</h1>
				</div>
			</div>
			<div class="row g-5 justify-content-center">
				<div class="col-lg-9 col-xl-8">
					<div class="design-bloc sec-title b-r-6">
						<p class="px-xl-4">Whether you need a full-service solution that includes prospect database
							evaluation and verification, content creation, and call center services, or you simply need
							to outsource a call center solution to help set meetings, CAP Digisoft has a solution that’s
							right for you. As a local, US-based company you can rest assured the you don’t need to deal
							the hassles of working with an overseas company. </p>
					</div>
				</div>
				<div class="col-lg-10 design-sec">
					<div class="row g-lg-0 g-4">
						<div class="col-md-4 border-end pe-lg-4">
							<h1 class="fw-medium"><span class="counter">71</span><span>%</span></h1>
							<h6 class="mt-2 fw-400 f-18">of customers who contact customer service do so over the phone.
							</h6>
						</div>
						<div class="col-md-4 border-end px-lg-4">
							<h1 class="fw-medium"><span class="counter">65</span><span>%</span></h1>
							<h6 class="mt-2 fw-400 f-18">of people say that the phone is the easiest-to-use customer
								service channel, making it the #1 choice.</h6>
						</div>
						<div class="col-md-4 px-lg-4 border-start border-white">
							<h1 class="fw-medium"><span class="counter">61</span><span>%</span></h1>
							<h6 class="mt-2 fw-400 f-18">of callers feel that artificial interactive voice response
								(IVR) systems provide a negative customer experience.</h6>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="bg-light section-padding">
		<div class="container custom-cn-width">
			<div class="row g-xl-5 g-4 justify-content-center">
				<div class="col-xl-7 col-lg-8 col-md-10">
					<div class="mb-xl-5 text-center">
						<h1 class="fw-light">Nearshore Call Center Outsourcing comes with many benefits.</h1>
						<h5 class="mt-3 fw-400">Nearshore outsourcing benefits include:</h5>
					</div>
				</div>
			</div>
			<div class="row g-xl-5 g-4 justify-content-center text-center text-xl-start mw-500">
				<div class="col-xl-4 order-xl-1 col-lg-9">
					<div class="row g-lg-5 g-4 justify-content-center">
						<div class="col-12 d-xl-flex align-items-start">
							<div class="me-xl-4">
								<div
									class="icons gradient-purple mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
									<img src={icon1} class="img-fluid" alt="Closer Proximity" /></div>
							</div>
							<div>
								<h4>Closer Proximity</h4>
								<p class="mt-3">Offshore call centers require lengthy travel to visit in person, making
									it difficult to do regularly. Our nearshore centers are close enough to make travel
									much more convenient, which also gives you more transparency into operations and
									lets you more easily make necessary adjustments. We’re also a Texas-based, US
									company meaning you don’t have to deal with the hassle of interacting with a
									foreign-managed business.</p>
							</div>
						</div>
						<div class="col-12 d-xl-flex align-items-start">
							<div class="me-xl-4">
								<div
									class="icons mb-4 d-flex align-items-center justify-content-center mx-auto gradient-blue rounded-pill">
									<img src={icon2} class="img-fluid" alt="Similar Culture" /></div>
							</div>
							<div>
								<h4>Similar Culture</h4>
								<p class="mt-3">One of the challenges of offshore centers are the large cultural
									barriers that exist between the US and countries like India or China. Our Nearshore
									center is close enough to the US that cultural differences are minimal, and our
									trained agents understand the nuances of American speech and preferences.</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-4 col-lg-9 order-xl-2">
					<div class="row g-lg-5 g-4 justify-content-center ">
						<div class="col-12 d-xl-flex align-items-start">
							<div class="me-xl-4">
								<div
									class="icons gradient-yellow mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
									<img src={icon3} class="img-fluid" alt="Stronger Infrastructure" /></div>
							</div>
							<div>
								<h4>Stronger Infrastructure</h4>
								<p class="mt-3">The reliability of offshore call centers is a reasonable concern for
									businesses. Offshore call centers, especially ones located in developing nations,
									can suffer from unreliable infrastructure. Our nearshore center, on the other hand,
									has a much more developed infrastructure which means stronger internet connections,
									far fewer dropped calls, and more dependable processes.</p>
							</div>
						</div>
						<div class="col-12 d-xl-flex align-items-start">
							<div class="me-xl-4">
								<div
									class="icons mb-4 d-flex align-items-center justify-content-center mx-auto gradient-pink rounded-pill">
									<img src={icon4} class="img-fluid" alt="Affordable Costs" /></div>
							</div>
							<div>
								<h4>Affordable Costs</h4>
								<p class="mt-3">Though many businesses consider on-site call centers as outside of their
									budgets, nearshore call centers are an alternative that can result in a 30%-40%
									operation cost reduction for your company. Our expertly trained agents and latest
									call center technology can reduce the costs for equipment and facilities, allowing
									you to make your money work harder.</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-4 col-lg-9 d-xl-flex align-items-start order-xl-2">
					<div class="me-xl-4">
						<div
							class="icons mb-4 d-flex align-items-center justify-content-center mx-auto gradient-green rounded-pill">
							<img src={icon5} class="img-fluid" alt="Shared Time Zones" /></div>
					</div>
					<div>
						<h4>Shared Time Zones</h4>
						<p class="mt-3">Coordinating communication and scheduling shifts between US offices and an
							offshore team on the other side of the world can be difficult when differences in time zones
							need to be considered. Offshore employees can often be working on opposite schedules, for
							example while the US team is asleep. Our nearshore call center is based on Central Standard
							Time (CST) making it much easier to work with each other during normal business hours.</p>
					</div>
				</div>
				<div class="col-xl-4 col-lg-9 d-xl-flex align-items-start order-xl-3">
					<div class="me-xl-4">
						<div
							class="icons mb-4 d-flex align-items-center justify-content-center mx-auto gradient-orange rounded-pill">
							<img src={icon6} class="img-fluid" alt="Easier Communication" /></div>
					</div>
					<div>
						<h4>Easier Communication</h4>
						<p class="mt-3">Our highly trained nearshore agents have a much better grasp of English and the
							nuances of the language, many having learned English in grade school. This means easier and
							more engaging conversations with your customers, and an easier time communicating in
							meetings and over email.</p>
					</div>
				</div>
				<div class="col-xl-4 col-lg-9 d-xl-flex align-items-start order-xl-3">
					<div class="me-xl-4">
						<div
							class="icons mb-4 d-flex align-items-center justify-content-center mx-auto gradient-purple rounded-pill">
							<img src={icon7} class="img-fluid" alt="Seamless Integration" /></div>
					</div>
					<div>
						<h4>Seamless Integration</h4>
						<p class="mt-3">Our Nearshore Call Center used the latest Five9 Call Center software, meaning
							you benefit from seamless integration with all the leading providers, rapid deployment, and
							feature such as locally originating numbers. This means our Call Center agents can easily
							and intelligently support your internal teams for a much smoother and productive operation.
						</p>
					</div>
				</div>
				<div class="col-xl-4 col-md-6 order-xl-1">
					<div class="about-border right zoom p-0">
						<div class="overflow-hidden border-white border-20">
							<img src={cutout1} alt="" class="border-0" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="inner-client-sec nsc-client-img bg-img section-padding">
		<div class="container custom-cn-width position-relative z-index-1">
			<div class="row align-items-center g-4 justify-content-end">
				<div class="col-lg-8">
					<div class="px-lg-">
						<h1 class="fw-400"><i class="fa fa-quote-left me-2"></i>The service package offered by CAP
							DIGISOFT is excellent, impressive and very professional. They have a superb qualified team
							to execute tasks that not only meets our own quality standards, but also those of our
							clients who are asked to respond to the marketing emails. You guys just did amazing work for
							us, which is already paying off. Thanks<i class="fa fa-quote-right ms-2"></i></h1>
						<h4 class="fw-400 mt-4 pt-lg-3">- Director Offshore Delivery, M&amp;A Firm</h4>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section className="section-padding">
		<div class="container custom-cn-width">
			<div class="row g-xl-5 g-4 align-items-center justify-content-center text-center">
				<div class="col-xxl-7 col-xl-8 col-lg-9">
					<h1 class="fw-light mb-lg-4 mb-3">Discover the CAP Digisoft Difference</h1>
					<p class="px-xl-4">Our highly-skilled, cost-effective, nearshore call center brings you the benefit
						of trained agents and a technology partner ready to invest in the success of your company.
					</p>
				</div>
			</div>
		</div>
	</section>
	<section class="p-0 text-center text-lg-start">
		<div class="container custom-cn-width">
			<div class="cta-block cta-violet b-r-6">
				<div class="row g-xl-5 g-4 align-items-center justify-content-center">
					<div class="col-lg-9">
						<h2 class="fw-light">Custom knowledge process outsourcing services that can solve even the most
							complex and non-standard business process challenges.</h2>
					</div>
					<div class="col-lg-3 text-lg-end">
						<a href="javascript:;" class="default-btn solution_class_popu" data-bs-toggle="modal"
							data-bs-target="#meeting" form_title="Knowledge Process Outsourcing">Let's Talk</a>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="text-center client-block section-padding">
		<div class="container">
			<div class="row g-lg-5 g-4 justify-content-center">
				<div class="col-lg-12 mb-4 mb-lg-5">
					<h1 class="px-lg-4 ">
						Trusted by more than{" "}
						<span class="text-theme fw-bold text-grad">3000+</span> clients
						globally
					</h1>
				</div>
			</div>
			<Slide className="brand-slider" {...properties} slidesToScroll={1} slidesToShow={4} indicators={false}
				autoplay={true}>
				<div class="each-slide-effect">
					<img src={c1} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c2} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c3} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c4} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c5} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c6} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c7} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c8} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c9} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c10} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c11} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c12} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c13} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c14} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c15} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c16} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c17} alt="Logo" class="img-fluid mb-1" />
				</div>

				<div class="each-slide-effect">
					<img src={c19} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c20} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c21} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c22} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c23} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c24} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c25} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c26} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c27} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c28} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c29} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c30} alt="Logo" class="img-fluid mb-1" />
				</div>
				<div class="each-slide-effect">
					<img src={c31} alt="Logo" class="img-fluid mb-1" />
				</div>
			</Slide>
		</div>
	</section>
	<section class="other-sec pt-0 section-padding">
		<div class="container custom-cn-width">
			<div class="row g-5 text-center">
				<div class="col-lg-12 mb-lg-5 mb-4">
					<h1 class="fw-light">Other Solutions</h1>
				</div>
			</div>
			<div class="">
				<div class="row g-4 g-xl-5 text-center text-xl-start">
					<div class="col-lg-4 col-md-6">
						<fieldset class="transition">
							<legend class="text-xl-start">KPO</legend>
							<div class="d-flex flex-column justify-content-between h-100">
								<h4 class="transition mb-2 mb-lg-3">Knowledge Process Outsourcing</h4>
								<a class="d-inline-block underline-border"
									href="knowledge-process-outsourcing"><span
										class="border-line d-inline-block me-1">Learn more</span><i
										class="fa fa-arrow-right fa-sm position-relative"></i></a>
							</div>
						</fieldset>
					</div>
					<div class="col-lg-4 col-md-6">
						<fieldset class="transition">
							<legend class="text-xl-start">Product</legend>
							<div class="d-flex flex-column justify-content-between h-100">
								<h4 class="transition mb-2 mb-lg-3">Idea to Product</h4>
								<a class="d-inline-block underline-border" href="idea-to-product"><span
										class="border-line d-inline-block me-1">Learn more</span><i
										class="fa fa-arrow-right fa-sm position-relative"></i></a>
							</div>
						</fieldset>
					</div>
					<div class="col-lg-4 col-md-6">
						<fieldset class="transition">
							<legend class="text-xl-start">marketing</legend>
							<div class="d-flex flex-column justify-content-between h-100">
								<h4 class="transition mb-2 mb-lg-3">Marketing and Consulting Services</h4>
								<a class="d-inline-block underline-border" href="marketing-and-consulting"><span
										class="border-line d-inline-block me-1">Learn more</span><i
										class="fa fa-arrow-right fa-sm position-relative"></i></a>
							</div>
						</fieldset>
					</div>
				</div>
			</div>
		</div>
	</section>
	<FooterOne />
</div>
);
};

export default Products;